module.exports = {
    HYDRO: '4',
    PLUVIO: '2',
    PIEZO: '1',
}